
import { motion } from "framer-motion";
import { Code2, Globe2, Layers } from "lucide-react";
import { TECH_STACK } from "../lib/data";

export const About = () => {
  const prefix = "//";

  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-[#060c1c]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-4">
          <span> {prefix} About the Studio</span>
        </div>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter max-w-4xl mb-16">
          One developer. <span className="text-gradient-cyan">Zero compromise.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-rows-2 gap-5 auto-rows-min">
          {/* Bio - large */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="md:col-span-4 md:row-span-2 p-8 md:p-10 rounded-2xl border border-white/5 bg-[#0a1024]"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center font-black text-[#040814] text-2xl shadow-lg shadow-cyan-500/30">
                S
              </div>
              <div>
                <div className="font-semibold text-lg">Sachin</div>
                <div className="text-sm text-cyan-400">Founder · Lead Developer</div>
              </div>
            </div>
            <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-5">

              I'm a <span >Principal Software Engineer at Rubix and former Senior Engineer at Ensurity Technologies </span> where I built applications serving 10,000+ users. I
              has shipped products for crypto explorers, fintech startups and SaaS platforms - AgentDNA, Jupiter Meta,
              Rubix, Trie Network, Ensurity and more.
            </p>
            <p className="text-slate-400 leading-relaxed">
              RS Digital Web Studio is where I bring that same elite engineering to the businesses I love most:
              the bakery on the corner, the dentist down the lane, the gym my friend opened. You deserve a
              website that looks like it cost ten times what you paid.
            </p>
          </motion.div>

          {/* Stat 1 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="md:col-span-2 p-7 rounded-2xl border border-cyan-400/20 bg-gradient-to-br from-cyan-500/10 to-blue-600/5"
          >
            <Code2 className="text-cyan-400 mb-3" size={26} />
            <div className="text-4xl font-black tracking-tighter mb-1">10+ years</div>
            <div className="text-slate-400 text-sm">building production-grade web applications</div>
          </motion.div>

          {/* Stat 2 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="md:col-span-2 p-7 rounded-2xl border border-white/5 bg-[#0a1024]"
          >
            <Globe2 className="text-cyan-400 mb-3" size={26} />
            <div className="text-4xl font-black tracking-tighter mb-1">Worldwide</div>
            <div className="text-slate-400 text-sm">I'm based in India (IST) and hold video calls during UK mornings and USA evenings.</div>
          </motion.div>
        </div>

        {/* Tech stack marquee */}
        <div className="mt-12">
          <div className="flex items-center gap-3 mb-6">
            <Layers size={16} className="text-cyan-400" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
              Tools of the trade
            </span>
          </div>

          <div className="relative overflow-hidden border-y border-white/5 py-6">

            {/* left fade */}
            <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#060c1c] to-transparent z-10" />

            {/* right fade */}
            <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#060c1c] to-transparent z-10" />

            <div className="flex gap-10 animate-marquee whitespace-nowrap">

              {[...TECH_STACK, ...TECH_STACK].map((tech, i) => {
                const Icon = tech.icon;

                return (
                  <div
                    key={i}
                    className="
              flex items-center gap-3
              px-5 py-3
              rounded-xl
              bg-white/[0.03]
              border border-white/5
              hover:border-cyan-400/30
              hover:bg-white/[0.05]
              transition-all
              group
            "
                  >
                    <Icon
                      size={28}
                      className="
    text-cyan-400
    opacity-80
    group-hover:scale-110
    transition-all
  "
                    />

                    <span className="text-lg font-semibold text-slate-500 group-hover:text-white transition-colors">
                      {tech.name}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
